<div class="row">
  <div class="col-12">
    <nb-card>
      <nb-card-body class="d-flex flex-column justify-content-center">
        <img src="../../../assets/images/not-found.svg" class="mb-3" height="200" alt="Not found" />
        <h4 class="text-center mb-4">{{msg?msg: "not_found" | translate}}</h4>
        <a [routerLink]="'/' + ($clientId | async) + '/home'" class="text-center">
          <button nbButton size="medium" status="primary" class="mt-auto mx-auto">
            {{'home' | translate }}
          </button>
        </a>
      </nb-card-body>
    </nb-card>
  </div>
</div>
